import { faCheckCircle, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { ActionButtons } from '../Shared/ActionButtons';
import { Tooltip } from '@mui/material';

export default function SubscriptionCard({
  name,
  description,
  price,
  addOnList,
  type,
  subscriptionType,
  handleButtonClick,
  handleOnCheckAddOn,
  handleCancelSubscription,
}: {
  name: string;
  description: string;
  price: number;
  addOnList: any;
  type: string;
  subscriptionType: string;
  handleButtonClick?: () => void;
  handleCancelSubscription?: () => void;
  handleOnCheckAddOn?: (id: number, is_enabled: boolean, price: number) => void;
}) {
  const enhanceDescription = (html: string) => {
    if (!html) return '';
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const listItems = doc.querySelectorAll('li');

    listItems.forEach((li) => {
      const icon = document.createElement('i');
      icon.className = 'fa fa-check';
      icon.style.marginRight = '5px';
      icon.style.color = '#48af98';
      li.insertBefore(icon, li.firstChild);
    });

    const list = doc.querySelector('ul, ol');
    if (list && listItems.length > 10) {
      list.classList.add('subscription-description-two-columns');
    }

    return doc.body.innerHTML;
  };

  // Enhance the description
  description = enhanceDescription(description);

  return (
    <div
      className={
        type === 'choose'
          ? 'subscription-card__custom-card'
          : 'subscription-card'
      }
    >
      <div className='subscription-card__header'>
        <div className='subscription-card__title'>
          <FontAwesomeIcon
            icon={
              subscriptionType == 'project_based' ? faCheckCircle : faUserCircle
            }
            className='subscription-card__title__icon'
          />
          {name}
        </div>
        <div className='subscription-card__price'>
          ${Number(price).toFixed(2)}&nbsp;
          <span className='subscription-card__price__month'>/mo</span>
        </div>
      </div>
      <div className='subscription-card__divider'></div>
      <div
        className='subscription-card__description'
        dangerouslySetInnerHTML={{ __html: description }}
      />
      {addOnList.length > 0 && type != 'choose' && (
        <div className='subscription-card__addOns'>
          <h3 style={{ fontWeight: '600' }}>Add On</h3>
          <div className='subscription-card__divider-dashed'></div>
          {addOnList.map((addOn: any) => (
            <div
              key={addOn.id}
              className='subscription-add-on-list'
              style={{
                opacity: addOn.is_enabled ? 1 : 0.5,
                display:
                  type === 'change' && !addOn.is_enabled ? 'none' : 'flex',
              }}
            >
              {type === 'change' && (
                <div className='subscription-add-on-list__checkbox'>
                  <input
                    type='checkbox'
                    checked={addOn.is_enabled_tenant}
                    onClick={() =>
                      handleOnCheckAddOn &&
                      handleOnCheckAddOn(
                        addOn.id,
                        addOn.is_enabled_tenant,
                        addOn.price,
                      )
                    }
                  />
                </div>
              )}
              <div className='subscription-add-on-list__name'>
                <div className='subscription-add-on-list__name__title'>
                  <div className='subscription-card__addOns-name'>
                    {addOn.name}
                  </div>
                  {addOn.as_per_project_usage && (
                    <Tooltip
                      title='This feature will incur charges based on its usage across projects. Charges will be calculated per project, based on the extent of usage of this feature.'
                      placement='top'
                      arrow
                      enterTouchDelay={0}
                    >
                      <div className='subscription-add-on-list__name__tag'>
                        As per Project Usage
                      </div>
                    </Tooltip>
                  )}
                </div>
                <h3
                  style={{
                    fontSize: '15px',
                    padding: '0px',
                  }}
                >
                  {addOn.description}
                </h3>
              </div>
              <div className='subscription-card__addOns-price'>
                ${addOn.price}
              </div>
            </div>
          ))}
        </div>
      )}
      {(type === 'edit' || type === 'change') && (
        <div className='subscription-card__button-holder'>
          <ActionButtons
            primary={type === 'edit' ? 'Edit Plan' : 'Change Plan'}
            className='subscription-card__button'
            onClick={handleButtonClick}
          />
          {type === 'change' && <ActionButtons
            primary={'Cancel Plan'}
            className='subscription-card__button'
            onClick={handleCancelSubscription}
          />}
        </div>
      )}
    </div>
  );
}
